import styled from '@emotion/styled'
import { Discount, Discounts } from '@open-tender/types'
import { Reward } from 'components'

const RewardsView = styled.div`
  opacity: 0;
  animation: slide-up 0.25s ease-in-out 0.25s forwards;
`

const RewardsContainer = styled.div`
  margin: 0 -1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin: 0 -0.5rem;
  }
`

const RewardView = styled.div`
  width: 33.33333%;
  padding: 0 1rem 2.5rem;
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 50%;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    width: 50%;
    padding: 0 0.5rem 2.5rem;
  }
`

const Rewards = ({
  rewards,
  renderItem = Reward,
}: {
  rewards: Discounts
  renderItem?: ({ item }: { item: Discount }) => JSX.Element
}) => {
  return (
    <RewardsView>
      <RewardsContainer>
        {rewards.map((reward, index) => (
          <RewardView key={`${reward.discount_id}-${index}`}>
            {renderItem({ item: reward })}
          </RewardView>
        ))}
      </RewardsContainer>
    </RewardsView>
  )
}

export default Rewards
